import { Mapper } from "@shared/interfaces";

export interface IUserDTO {
    id?: string;
    idUser: string;
    firstName: string;
    lastName: string;
    email: string;
}

export class UserDTO implements Mapper<IUserDTO> {
    constructor(
        public idUser: string,
        public firstName: string,
        public lastName: string,
        public email: string,
        public id?: string
    ) { }

    public getJSON(): IUserDTO {
        const jsonObject = {
            idUser: this.idUser,
            firstName: this.firstName,
            lastName: this.lastName,
            email: this.email
        }

        return jsonObject;
    }
}
